import { Edit3Icon, Icon } from '@vrplatform/icons';
import {
  EllipsisMenuCopyItem,
  EllipsisMenuDivider,
  EllipsisMenuItem,
} from '@vrplatform/components-legacy';
import {
  parseAsString,
  useQueryState,
  useQueryStates,
} from '@vrplatform/query-params';
import { useMemo } from 'react';
import {
  EllipsisMenuSourceDownloadItem,
  HiddenFeatureIndicator,
} from '../../../components';
import { getListingDeactivationAction } from '../detail/_components';
import type { ListingData } from '../detail/useListingDetailViewQuery';
import { useListingDetailDrawer } from '../drawer';

type Props = {
  listing: {
    id: string;
    deactivation: ListingData['deactivation'] | undefined;
  };
  handlers: {
    // openDeleteModal: () => void;
    openDeactivationModal: () => void;
    openOpeningBalanceModal: () => void;
  };
  hideEdit?: boolean;
};

export const ListingEllipsisMenuItems = ({
  handlers: { openDeactivationModal, openOpeningBalanceModal },
  listing: { deactivation, id: listingId },
  hideEdit,
}: Props) => {
  const [, setListingId] = useQueryState('listing_activity', parseAsString);

  const { open: openListingDetail } = useListingDetailDrawer();

  const [, setView] = useQueryStates({
    view: parseAsString,
    listing: parseAsString,
  });

  const deactivationAction = useMemo(() => {
    if (!deactivation) return undefined;

    return getListingDeactivationAction(
      deactivation.status,
      openDeactivationModal
    );
  }, [deactivation, openDeactivationModal]);

  return (
    <>
      {!hideEdit && (
        <EllipsisMenuItem
          onClick={() => setView({ listing: listingId, view: 'edit' })}
          customIcon={<Edit3Icon size={16} />}
        >
          Edit listing
        </EllipsisMenuItem>
      )}

      <EllipsisMenuItem
        customIcon={<Icon icon="HistoryIcon" size={16} />}
        onClick={() => setListingId(listingId, { history: 'push' })}
      >
        View activity
      </EllipsisMenuItem>

      {deactivationAction && (
        <EllipsisMenuItem
          onClick={deactivationAction.onClick}
          customIcon={
            deactivationAction.icon && (
              <Icon icon={deactivationAction.icon} size={16} />
            )
          }
        >
          {deactivationAction.label}
        </EllipsisMenuItem>
      )}

      <EllipsisMenuDivider />
      <EllipsisMenuItem
        onClick={openOpeningBalanceModal}
        customIcon={<Icon icon="CircleDollarIcon" size={16} />}
      >
        Update starting balance
      </EllipsisMenuItem>

      {/* <EllipsisMenuDivider />

      <EllipsisMenuDangerItem onClick={openDeleteModal}>
        Delete listing
      </EllipsisMenuDangerItem> */}

      <HiddenFeatureIndicator permission="vrp-admin">
        <EllipsisMenuItem
          onClick={() => openListingDetail(listingId)}
          customIcon={<Icon icon={'EyeIcon'} size={16} />}
        >
          Quick view
        </EllipsisMenuItem>

        <EllipsisMenuCopyItem value={listingId} />

        <EllipsisMenuSourceDownloadItem
          fileName={listingId}
          where={{ listing: { id: { _eq: listingId } } }}
        />
      </HiddenFeatureIndicator>
    </>
  );
};
